import type { BadgeId, GameEventDto, RankId } from '@rw/shared';
import { badgeTierName, rankName } from '../achievements/achievements';
import { formatKm } from '../../lib/format';
import { t } from '../../i18n';

export function describeEvent(e: GameEventDto, me: string | null): { icon: string; text: string } | null {
  const who = e.user ? (e.user.id === me ? t('You') : e.user.displayName) : t('Someone');
  const p = e.payload as Record<string, unknown>;
  switch (e.type) {
    case 'TERRITORY_CAPTURED':
      return { icon: '⬢', text: t('{who} captured sector {key}', { who, key: e.territory?.gridKey ?? '' }) };
    case 'TERRITORY_LOST':
      return e.user?.id === me ? { icon: '⚔️', text: t('You lost sector {key}', { key: e.territory?.gridKey ?? '' }) } : null;
    case 'RUN_FINISHED':
      return p.status === 'VALID' ? { icon: '🏁', text: t('{who} ran {km} km', { who, km: formatKm(Number(p.distanceM ?? 0)) }) } : null;
    case 'LEVEL_UP':
      return { icon: '⭐', text: t('{who} reached level {n}', { who, n: String(p.level) }) };
    case 'RANK_UP':
      return { icon: '🎖️', text: t('{who} reached the {rank} rank', { who, rank: rankName(p.rank as RankId) }) };
    case 'BADGE_EARNED':
      return { icon: '🏅', text: t('{who} unlocked the {badge} badge', { who, badge: badgeTierName(p.badge as BadgeId, Number(p.tier)) }) };
    default:
      return null;
  }
}
